import queryString from "query-string";
import { api, authHeader } from "../configs/axiosConfigs";

const SuppliersApiService = {
  getActiveSuppliers: async (params) => {
    const response = await api.request({
      url: `/api/Suppliers/GetActiveSuppliers?${queryString.stringify(
        params || {}
      )}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getVerifiedSuppliers: async (params) => {
    const response = await api.request({
      url: `/api/Suppliers/GetVerifiedSuppliers?${queryString.stringify(
        params || {}
      )}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getSupplierDetails: async (supplierId) => {
    const response = await api.request({
      url: `/api/Suppliers/GetSupplierWithProducts?id=${supplierId}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  searchSuppliers: async (filters) => {
    const response = await api.request({
      url: `/api/Suppliers/SearchSuppliers?${queryString.stringify(
        filters || {}
      )}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getSupplierProducts: async (supplierId, params) => {
    const response = await api.request({
      url: `/api/Suppliers/GetSupplierProducts?supplierId=${supplierId}&${queryString.stringify(
        params || {}
      )}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  searchProducts: async (filters) => {
    const response = await api.request({
      url: `/api/Suppliers/SearchProducts?${queryString.stringify(
        filters || {}
      )}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getMyProducts: async (filters) => {
    const response = await api.request({
      url: `/api/Suppliers/GetMyProducts?${queryString.stringify(
        filters || {}
      )}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  createProduct: async (data) => {
    const response = await api.request({
      url: `/api/Suppliers/CreateProduct`,
      method: "POST",
      headers: authHeader(),
      data,
    });
    return response.data;
  },

  updateProduct: async (data) => {
    const response = await api.request({
      url: `/api/Suppliers/UpdateProduct`,
      method: "PUT",
      headers: authHeader(),
      data,
    });
    return response.data;
  },

  deleteProduct: async (productId) => {
    const response = await api.request({
      url: `/api/Suppliers/DeleteProduct/${productId}`,
      method: "DELETE",
      headers: authHeader(),
    });
    return response.data;
  },

  getProductDetails: async (productId) => {
    const response = await api.request({
      url: `/api/Suppliers/GetProductDetails/${productId}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },
};

export default SuppliersApiService;
